import { render, staticRenderFns } from "./uploadMulty.vue?vue&type=template&id=8fc211f4&"
import script from "./uploadMulty.vue?vue&type=script&lang=js&"
export * from "./uploadMulty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports